export default function Tabs({ tabs, activeTab, onChange }) {
  return (
    <div className="flex gap-1 overflow-x-auto border-b border-border-default">
      {tabs.map(({ key, label, icon: Icon }) => (
        <button
          key={key}
          onClick={() => onChange(key)}
          className={`
            flex items-center gap-2 px-4 min-h-touch
            text-body whitespace-nowrap border-b-2 transition-colors duration-state
            ${activeTab === key
              ? 'border-accent text-accent font-semibold'
              : 'border-transparent text-ink-muted hover:text-ink'}
          `}
        >
          {Icon && <Icon size={18} strokeWidth={1.5} />}
          {label}
        </button>
      ))}
    </div>
  );
}
